module.exports = __webpack_public_path__ + "static/media/tottori.55cac8db.png";